import { isoStringRegex } from '@shared/constants/regex.const';
import { eachDayOfInterval, endOfMonth, isAfter, isDate, isSameDay, isValid, set, startOfDay, startOfMonth } from 'date-fns';

export const validDate = (value: string | Date): boolean => {
    const regexPassed = isoStringRegex.test(value instanceof Date ? value.toISOString() : value);
    if (!regexPassed) {
        return false;
    }
    const testDate = new Date(value);
    const validTime = !isNaN(testDate.getTime());
    const validISOConversion = testDate.toISOString() === (value instanceof Date ? value.toISOString() : value);
    return validTime && validISOConversion;
};

export const toApiUtcDate = (date: Date): Date => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return undefined;
    }
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
};

export const fromApiUtcDate = (utcDate: Date): Date => {
    if (!(utcDate instanceof Date) || isNaN(utcDate.getTime())) {
        return undefined;
    }

    return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), utcDate.getUTCHours(), utcDate.getUTCMinutes(), utcDate.getUTCSeconds());
};

export const getDaysInMonth = (date: Date): Date[] => {
    return eachDayOfInterval({
        start: startOfMonth(date),
        end: endOfMonth(date),
    });
};

export const isValidDate = (date: unknown): date is Date => {
    return isDate(date) && isValid(date);
};

export const isSameOrAfterDay = (date: Date, compareTo: Date): boolean => {
    return isAfter(startOfDay(date), startOfDay(compareTo)) || isSameDay(date, compareTo);
};

export const setToStartOfDay = (date: Date): Date => {
    date.setHours(0, 0, 0, 0);
    return date;
};

/** Unisce il giorno di `date` con ore e minuti di `time`, azzerando secondi e millisecondi. */
export const mergeDateAndTime = (date: Date, time: Date): Date => {
    if (!isValidDate(date)) {
        return undefined;
    }
    return set(startOfDay(date), { hours: time?.getHours() ?? 0, minutes: time?.getMinutes() ?? 0 });
};
